/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Dubbing_Export_Video_LabelInputs */



/**
* | output |
* | --- |
* | "Export Video" |
*
* @param {Audio_Dubbing_Export_Video_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_dubbing_export_video_label = /** @type {((inputs?: Audio_Dubbing_Export_Video_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Dubbing_Export_Video_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter la vidéo")
	if (locale === "de") return /** @type {LocalizedString} */ ("Video exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт видео")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar video")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出视频")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオをエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar vídeo")
	return /** @type {LocalizedString} */ ("Export Video")
});